import React from 'react';
import Layout from '../../components/Layout';
import GiftCards from './GiftCards';

const title = 'BestHand Gift Cards — Coming Soon';
const description =
  'BestHand gift cards are coming soon — give the gift of a trusted local pro for repairs, cleaning, mounting and more. Sign up to be notified at launch.';

function action() {
  return {
    title,
    description,
    component: (
      <Layout>
        <GiftCards />
      </Layout>
    ),
  };
}

export default action;
